import React from "react";
import { array } from "prop-types";

const propTypes = {
  sidebar: array,
};

const AdditionalPrograms = (props) => {
  const { sidebar } = props;

  return (
    <>
      <div className="search-component__related-heading">Related</div>
      {sidebar.map((item, ind) => (
        <section key={ind} className="search-component__related-item">
          <div className="search-component__related-item-type">
            {item.contentType}
          </div>
          <div className="search-component__related-item-title">
            <a href={item.link}>{item.title}</a>
          </div>
          <div className="search-component__related-item-desc">
            {item.summary}
          </div>
          {item.additionalLinks.length > 0 && (
            <div className="search-component__related-item-cta">
              <div className="search-component__related-item-cta-title">
                Additional Programs:
              </div>
              {item.additionalLinks.map((link, indd) => (
                <a key={indd} href={link.url}>
                  {link.title}
                </a>
              ))}
            </div>
          )}
        </section>
      ))}
    </>
  );
};

AdditionalPrograms.propTypes = propTypes;
export default AdditionalPrograms;
